import React, { Component } from 'react';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { compose, withApollo } from 'react-apollo';
import withGameSession from 'utils/withGameSession';
import withTransitionRoute from 'utils/withTransitionRoute';

class GameScoreContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gameScore: 0
    };

    this.scoreUpdatesSubscription = null;
  }

  componentDidMount() {
    this.subscribeToScoreUpdates();
  }

  componentWillUnmount() {
    if (this.scoreUpdatesSubscription) {
      this.scoreUpdatesSubscription.unsubscribe();
      this.scoreUpdatesSubscription = null;
    }
  }

  subscribeToScoreUpdates() {
    if (this.scoreUpdatesSubscription) {
      this.scoreUpdatesSubscription.unsubscribe();
    }
    const sessionId = this.props.gameSession.id;
    const that = this;
    this.scoreUpdatesSubscription = this.props.client
      .subscribe({
        query: SUBSCRIPTION_GAME_SCORE_UPDATES,
        variables: { input: { gameSessionId: sessionId } }
      })
      .subscribe({
        next(payload) {
          that.onScoreUpdate(payload.data);
        },
        error(err) {
          console.error('Error in GameScoreUpdate: ', err);
        }
      });
  }

  onScoreUpdate(data) {
    if (data && data.gameScore !== undefined) {
      this.setState({ gameScore: data.gameScore });
    }
  }

  render() {
    const { children, transitionClass } = this.props;
    const { gameScore } = this.state;

    return React.Children.map(children, child =>
      React.cloneElement(child, { gameScore, transitionClass })
    );
  }
}

GameScoreContainer.propTypes = {
  gameSession: PropTypes.shape({
    id: PropTypes.number
  }),
  transitionClass: PropTypes.string
};

const SUBSCRIPTION_GAME_SCORE_UPDATES = gql`
  subscription MyGameScoreUpdates($input: GameScoreUpdatesInput!) {
    gameScoreUpdates(input: $input) {
      gameScore
    }
  }
`;

const transitionProps = {
  pathFn: p => p.targetPath,
  shouldMountFn: p => p.gameSession,
  keyFn: p => (p.key || '') + (p.gameSession ? p.gameSession.id : '')
};

export default compose(
  withGameSession(),
  withTransitionRoute(transitionProps),
  withApollo
)(GameScoreContainer);
